import Vue from 'vue'
import paperweb from "../../components/paperweb/paperweb-preview";
import 'scroll-behavior-polyfill'
import showdown from 'showdown'
document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll(".paperweb")
    elements.forEach((element)=> {
        const app = new Vue({
            render: h => h(paperweb, {
                props: {
                    contentItems: JSON.parse(element.dataset.contentItems),
                    preview: true
                }})
        }).$mount();
        element.appendChild(app.$el);

    })
});
